module.exports = __webpack_public_path__ + "static/img/king_card_1.14ad7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/king_card_1.png
// module id = AkN2
// module chunks = 0